export function enabledLabel(v) {
  return v ? "Enabled" : "Disabled";
}

export function fieldChange(label, from, to) {
  return `${label}: ${from} → ${to}`;
}

export function arraysEqual(a, b) {
  const aa = Array.isArray(a) ? a : [];
  const bb = Array.isArray(b) ? b : [];
  if (aa.length !== bb.length) return false;
  const sa = [...aa].sort();
  const sb = [...bb].sort();
  return sa.every((x, i) => x === sb[i]);
}

/**
 * Compare baseline vs draft using a list of field descriptors.
 * Each entry: { key, label, format?, equal?, get? }
 */
export function collectObjectDiff(baseline, draft, entries) {
  if (!baseline || !draft) return [];
  const fields = [];
  for (const entry of entries) {
    const { key, label, format = (v) => String(v ?? "—"), equal, get } = entry;
    const read = get || ((obj) => obj[key]);
    const a = read(baseline);
    const b = read(draft);
    const changed = equal ? !equal(a, b) : a !== b;
    if (changed) {
      fields.push(fieldChange(label, format(a), format(b)));
    }
  }
  return fields;
}

/** Pending PATCH bucket — only `pending` keys, values read from baseline for "from". */
export function collectPendingDiff(pending, baseline, labelMap, formatters = {}) {
  if (!pending || !baseline) return [];
  return Object.keys(pending).map((key) => {
    const label = labelMap[key] || key;
    const format = formatters[key] || ((v) => String(v ?? "—"));
    return fieldChange(label, format(baseline[key]), format(pending[key]));
  });
}

export function cloneItems(items) {
  return (items || []).map((item) => ({ ...item }));
}

/** Compare saved vs working rule lists for enabled-toggle diffs. */
export function collectRuleEnabledDiff(savedRules, rules, getLabel = (r) => r.name || r.id, isEnabled = (r) => !!r.enabled) {
  const savedById = Object.fromEntries((savedRules || []).map((r) => [r.id, isEnabled(r)]));
  return (rules || [])
    .filter((r) => savedById[r.id] !== isEnabled(r))
    .map((r) => fieldChange(
      getLabel(r),
      enabledLabel(savedById[r.id]),
      enabledLabel(isEnabled(r)),
    ));
}
